import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { mapMutations } from 'vuex';
export default {
  data: function data() {
    return {
      status: {
        isLoadingDict: false
      }
    };
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('d2admin/dict', {
    dictSet: 'set'
  })), {}, {
    /**
     * @description 加载需要的字典数据
     * @description 这个方法一般在页面上需要再次实现
     * @description 在此方法内使用 loadDictOne
     * @description loadDict 会自动以 doLoadDict(loadDict) 的形式被调用
     * @description doLoadDict -> loadDict -> loadDictOne
     * @description 在 d2-dict-x 类组件上使用的普通的字典会自动加载 无需再次使用此方法
     */
    loadDict: function loadDict() {},

    /**
     * @description 加载一个字典
     * @param {Object} config {String} name 字典名称
     * @param {Object} config {Function} method 请求方法
     * @param {Object} config {String} fields 需要的字段
     * @param {Object} config {Object} query 请求参数
     * @param {Object} config {String} path 返回数据的列表字段位置
     * @param {Object} config {String} label 字典 label 字段名
     * @param {Object} config {String} value 字典 value 字段名
     */
    loadDictOne: function loadDictOne(_ref) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ref$name, name, _ref$method, method, _ref$fields, fields, _ref$query, query, _ref$path, path, _ref$label, label, _ref$value, value, result, dictValue;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref$name = _ref.name, name = _ref$name === void 0 ? '' : _ref$name, _ref$method = _ref.method, method = _ref$method === void 0 ? function () {} : _ref$method, _ref$fields = _ref.fields, fields = _ref$fields === void 0 ? '' : _ref$fields, _ref$query = _ref.query, query = _ref$query === void 0 ? {} : _ref$query, _ref$path = _ref.path, path = _ref$path === void 0 ? '' : _ref$path, _ref$label = _ref.label, label = _ref$label === void 0 ? 'label' : _ref$label, _ref$value = _ref.value, value = _ref$value === void 0 ? 'id' : _ref$value;
                _context.prev = 1;
                _context.next = 4;
                return method(Object.assign({
                  page_size: 9999
                }, fields ? {
                  fields: fields
                } : {}, query));

              case 4:
                result = _context.sent;
                dictValue = (path ? _this._.get(result, path, []) : result).map(function (e) {
                  return {
                    label: e[label],
                    value: e[value]
                  };
                });

                _this.dictSet({
                  name: name,
                  value: dictValue
                });

                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                console.log(_context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 9]]);
      }))();
    },

    /**
     * @description 请求字典数据
     * @param {Function} fn 请求函数 需要返回 Promise
     */
    doLoadDict: function doLoadDict() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var fn, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fn = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : function () {};
                _this2.status.isLoadingDict = true;
                _context2.prev = 2;
                _context2.next = 5;
                return fn();

              case 5:
                data = _context2.sent;
                _this2.status.isLoadingDict = false;
                return _context2.abrupt("return", Promise.resolve(data));

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](2);
                console.log(_context2.t0);
                _this2.status.isLoadingDict = false;
                return _context2.abrupt("return", Promise.reject(_context2.t0));

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 10]]);
      }))();
    }
  })
};